import { gql } from "@apollo/client"

export const ENROLLMENT_COST_CONTRIBUTION_FIELDS = gql`
  fragment EnrollmentCostContributionsFields on BenefitsEnrollmentCostContribution {
    id
    contributor
    amount
    amountAsPercentage
  }
`
